define('track-visibility',['underscore'], function(_) {
    'use strict';
    function trackVisibility(elems, onVisibilityChange, padding, threshold, autoUnobserve) {
        var callback = function(entries) {
            entries.forEach(function(entry) {
                onVisibilityChange({
                    element: entry.target,
                    visible: entry.isIntersecting,
                    ratio: entry.intersectionRatio,
                });

                if (entry.isIntersecting) {
                    if (autoUnobserve) {
                        observer.unobserve(entry.target);
                    }
                }
            });
        };

        var options = {
            rootMargin: padding + "px 0px " + padding + "px 0px",
            threshold: threshold || 0,
        }
        var observer = new IntersectionObserver(callback, options);
        for (var i = 0; i < elems.length; i++) {
            observer.observe(elems[i]);
        }

        return function() { observer.disconnect(); };
    }

    return trackVisibility;
});

